import React from "react";
import _ from "lodash";
import { Link } from "react-router";
import ReactGA from "react-ga";
import { getCurrentPage, trackLinkClick } from "../helpers";

class MainNav extends React.Component {
    toggleSidebar = (e) => {
        e.preventDefault();

        const newState = this.props.sidebar.status === "show" ? "hide" : "show";

        // GA Track
        ReactGA.event({
            category: _.startCase(getCurrentPage()),
            action: "Toggle Sidebar",
            label: newState,
        });

        this.props.setSidebar(newState);
    };

    cleanupRoutePlanning = () => {
        this.props.cleanupRoutePlanning(true);
    };

    cleanupLeisureRides = () => {
        this.props.clearFilters();
        this.props.removeOverlay("sitewide");
        this.props.clearPOI();
    };

    onFocus(e) {
        if (innerWidth >= 1000) {
            const header = document.querySelector(".main-header__col2");
            window.scrollTo(
                0,
                e.target.getBoundingClientRect().top - header.outerHeight / 2
            );
        }
    }

    trackLinkClick(event) {
        const link = event.target;
        const text = link.textContent;
        const href = link.getAttribute("href");
        ReactGA.event({
            category: _.startCase(getCurrentPage()),
            action: text,
            label: href,
        });
    }



    render() {
        return (
            <nav className="tabs">
                <Link
                    className="tab-link"
                    to="/route-planning"
                    onClick={event => {
                        this.cleanupRoutePlanning();
                        trackLinkClick(event);
                      }}
                    activeClassName="active-tab"
                    onFocus={this.onFocus}
                >
                    <svg>
                        <use href="#route-planner" />
                    </svg>
                    <span>Route Planner</span>
                </Link>
                <Link
                    className="tab-link"
                    to="/cycle-routes"
                    onClick={event => {
                        this.cleanupRoutePlanning();
                        trackLinkClick(event);
                    }}
                    
                    activeClassName="active-tab"
                    onFocus={this.onFocus}
                >
                    <svg>
                        <use href="#cycling-route" />
                    </svg>
                    <span>Cycle Routes</span>
                </Link>
                <Link
                    className="tab-link"
                    to="/leisure-rides"
                    onClick={event => {
                        this.cleanupLeisureRides();
                        trackLinkClick(event);
                    }}
                    activeClassName="active-tab"
                    onFocus={this.onFocus}
                >
                    <svg>
                        <use href="#leisure-ride" />
                    </svg>
                    <span>Leisure Rides</span>
                </Link>
                <Link
                    className="tab-link"
                    to="/cycle-hire"
                    onClick={event => {
                        this.cleanupRoutePlanning();
                        trackLinkClick(event);
                    }}
                    activeClassName="active-tab"
                    onFocus={this.onFocus}
                >
                    <svg>
                        <use href="#bike-rentals" />
                    </svg>
                    <span>Bike Shops & Rentals</span>
                </Link>
                <Link
                    className="tab-link"
                    to="/public-pumps"
                    onClick={event => {
                        this.cleanupRoutePlanning();
                        trackLinkClick(event);
                    }}
                    activeClassName="active-tab"
                    onFocus={this.onFocus}
                >
                    <svg>
                        <use href="#pump-white" />
                    </svg>
                    <span>Public Bike Pumps</span>
                </Link>
            </nav>
        );
    }
}

export default MainNav;



// WEBPACK FOOTER //
// ./src/components/MainNav.js